<div class="card">
  <!-- header -->
  <h2>
    <span class="material-symbols-rounded text-accent-600">label</span>
    Categorias
    <button
      [routerLink]="[{ outlets: { modal: ['add', ''] } }]"
      class="ml-auto tertiary !px-1 md:!px-3"
    >
      <span class="material-symbols-rounded m-auto text-black/60"> add </span>
      @if (sharedService.screenSize !== 's') {
        Adicionar
      }
    </button>
  </h2>

  <!-- body -->
  <kor-table columns="3fr 1fr">
    <kor-table-row slot="header">
      <kor-table-cell head>Nome</kor-table-cell>
      <kor-table-cell head>Atendentes ativos</kor-table-cell>
    </kor-table-row>
    @for (category of categoriesService.categories; track category) {
      <kor-table-row
        [routerLink]="[{ outlets: { modal: ['add', category.uid] } }]"
      >
        <kor-table-cell>
          <b>{{ category.label }}</b>
        </kor-table-cell>
        <kor-table-cell> {{ category.operators.length }} </kor-table-cell>
      </kor-table-row>
    }
  </kor-table>
</div>

<!-- modals -->
<router-outlet name="modal"></router-outlet>
